import { PropertyInformation } from 'pages/LoanApplication/PropertyInformation'

import AdditionalProperties from './AdditionalProperties'

/**
 * Property Information inside servicing.
 *
 * Renders the loan application's own PropertyInformation section rather than a copy, so the fields
 * and the records behind them are the same ones origination uses: an edit here is an edit there.
 *
 * Servicing adds one thing origination keeps on Loan Structure: the additional properties
 * themselves. A blanket loan takes on and gives up parcels long after it is priced, and until now
 * the table below could only list the ones origination had entered - there was no way to add
 * another one once the loan was being serviced.
 */
export default function ServicingPropertyInformation({ setLoading }: { setLoading: (loading: boolean) => void }) {
  return (
    <PropertyInformation
      setLoading={setLoading}
      beforeAdditionalProperties={(canEdit) => <AdditionalProperties canEdit={canEdit} />}
    />
  )
}
